import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { PUBLISHINGV2_FRAGMENT } from "./publishing-failed-notice.graphql";
import { listClass, noticeClass, titleClass } from "./publishing-failed-notice.styles";
import { type PublishingFailedNoticeProps } from "./publishing-failed-notice.types";
import { getPublishingFailure } from "./publishing-failed-notice.utils";

export const PublishingFailedNotice = ({
	publishingV2FragmentRef,
}: PublishingFailedNoticeProps) => {
	const { t } = useTranslation("common");
	const publishing = useFragment(PUBLISHINGV2_FRAGMENT, publishingV2FragmentRef);

	if (publishing?.status !== "failed") return null;

	const { contentsFailed, details } = getPublishingFailure(publishing.messages);

	return (
		<div className={noticeClass} role="alert" data-testid="publishing-failed-notice">
			<span className={titleClass}>{t("educationalOffer.publishingFailed.title")}</span>
			<span>
				{contentsFailed
					? t("educationalOffer.publishingFailed.contentsNotReleased")
					: t("educationalOffer.publishingFailed.unknown")}
			</span>
			{details.length > 0 && (
				<ul className={listClass}>
					{details.map((detail, index) => (
						<li key={index}>{detail}</li>
					))}
				</ul>
			)}
		</div>
	);
};
